import React from 'react';

export function LoginHeader() {
  return (
    <>
      <div class="d-md-none row m-0 p-0 bg-white">
        <nav class="navbar navbar-expand-sm p-0 border-bottom border-1 border-body">
          <div class="ps-2">
            <a class="navbar-brand p-0" href="/#">
              <img src="/images/logo.png" alt="Yawin Astro"  class="p-0 logostyle" />
              <span class="ps-2 logotitlestyle">Yawin</span>
            </a>   
         </div>
        </nav>
      </div>  
      <div class="d-none d-md-block row m-0 p-0 bg-white">
        <nav class="navbar navbar-expand-sm border-bottom border-1 border-body p-0">
          <div class="container-fluid ps-2">
            <a class="navbar-brand p-0" href="/#">
              <img src="/images/logo.png" alt="Yawin Astro"  class="p-0 logostyle" />
              <span class="ps-2 logotitlestyle">Yawin Astro</span>
            </a>   
          </div>
        </nav>
      </div>  
    </>
  );
}
